import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../context/AuthContext";
import { Radio, Timer, Trophy } from "lucide-react";

export default function LiveTiming({ rallyId, entries }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [view, setView] = useState("OVERALL");
  const myClass = (n) => entries.find(e => e.number === n)?.class_name;

  const load = () => axios.get(`${API}/paddock/rallies/${rallyId}/live`).then(r => { setData(r.data); setErr(null); }).catch(e => setErr(e.response?.data?.detail || "Live non disponibile"));
  useEffect(() => { load(); const iv = setInterval(load, 60000); return () => clearInterval(iv); }, [rallyId]);

  if (err) return <div className="rl-card p-8 text-center text-slate-500" data-testid="live-unavailable">{err}. La classifica live è attiva per i rally collegati al cronometraggio ufficiale FICR.</div>;
  if (!data) return <div className="text-center text-slate-500 py-10">Caricamento tempi ufficiali…</div>;

  const stage = view === "OVERALL" ? null : data.stages.find(s => s.ps === view);
  const rows = stage ? stage.results : data.overall;

  return (
    <div data-testid="live-timing">
      <div className="rl-banner rl-watermark p-6 mb-5 flex flex-wrap items-center justify-between gap-4">
        <div className="relative">
          <div className="pill-badge mb-2" style={{ background: "rgba(48,209,88,0.15)", color: "#30D158" }}><Radio className="w-3 h-3 animate-pulse" /> {data.finished ? "GARA CONCLUSA" : "LIVE"} · CRONOMETRAGGIO UFFICIALE FICR</div>
          <div className="font-display font-black text-2xl">{data.event || "Tempi ufficiali"}</div>
          <div className="text-xs font-mono-rl text-slate-400">PS completate {data.done_ps}/{data.total_ps} · aggiornato {new Date(data.updated_at).toLocaleTimeString("it-IT")}</div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-5">
        <button onClick={() => setView("OVERALL")} data-testid="live-view-overall"
          className={`px-3 py-1.5 rounded-full font-mono-rl text-[11px] uppercase tracking-widest transition flex items-center gap-1 ${view === "OVERALL" ? "bg-[#30D158] text-black" : "border border-white/10 text-slate-300"}`}><Trophy className="w-3 h-3" /> Assoluta{data.overall_after_ps ? ` dopo PS${data.overall_after_ps}` : ""}</button>
        {data.stages.map(s => (
          <button key={s.ps} onClick={() => s.status === 2 && setView(s.ps)} disabled={s.status !== 2} data-testid={`live-view-ps-${s.ps}`}
            className={`px-3 py-1.5 rounded-full font-mono-rl text-[11px] uppercase tracking-widest transition ${view === s.ps ? "bg-[#30D158] text-black" : "border border-white/10 text-slate-300 disabled:opacity-40"}`}>PS{s.ps} {s.name}</button>
        ))}
      </div>
      <div className="rl-card p-4 overflow-x-auto">
        {stage && <div className="text-xs font-mono-rl text-slate-400 mb-3 flex items-center gap-1"><Timer className="w-3 h-3" /> PS{stage.ps} {stage.name} · {stage.km} km</div>}
        {rows.length === 0 ? <div className="text-slate-500 text-center py-6">Nessun tempo ancora disponibile.</div> : (
          <table className="w-full text-sm">
            <thead className="text-[10px] font-mono-rl text-slate-500 uppercase tracking-widest">
              <tr><th className="text-left py-2 w-10">Pos</th><th className="text-left w-12">N°</th><th className="text-left">Equipaggio</th><th className="text-left hidden md:table-cell">Vettura</th><th className="text-left hidden sm:table-cell">Classe</th><th className="text-right">Tempo</th><th className="text-right hidden sm:table-cell">Distacco</th></tr>
            </thead>
            <tbody>
              {rows.map((x, i) => (
                <tr key={`${x.number}-${i}`} className={`border-t border-white/5 ${i < 3 ? "text-white" : "text-slate-300"}`} data-testid={`live-row-${x.number}`}>
                  <td className={`py-2 font-display font-black ${i === 0 ? "text-[#FF9F0A]" : ""}`}>{x.pos}</td>
                  <td className="font-mono-rl text-[#FF1E27]">#{x.number}</td>
                  <td><div className="font-semibold">{x.driver}</div><div className="text-[11px] text-slate-500">{x.codriver}</div></td>
                  <td className="hidden md:table-cell text-slate-400 text-xs">{x.car}</td>
                  <td className="hidden sm:table-cell text-xs text-[#FF9F0A]">{x.class_name || myClass(x.number) || ""}</td>
                  <td className="text-right font-mono-rl">{x.time}</td>
                  <td className="text-right font-mono-rl text-slate-500 hidden sm:table-cell">{x.gap}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
